// src/utils/widgetDataUpdater.ts

import { isLimitedTimeWidget } from "./widgetPatterns";
import type { MenuItem } from "../redux/slices/menuItemsSlice";
import type { Widget } from "./widgetUtils";

export function updateWidgetsWithLimitedTimeData(
  widgets: Widget[],
  menuData: MenuItem[], // Updated to receive menu items data
): Widget[] {
  return widgets.map((widget) => {
    if (!isLimitedTimeWidget(widget.type || "")) {
      return widget;
    }

    const selectedItemIds = widget.data?.selectedItemIds ?? [];

    // Filter to only include active/non-expired menu items for limited-time widgets
    const activeMenuData = menuData.filter(
      (item) => item.isMealTimeActive && !item.isMealTimeExpired
    );

    const updatedWidget: Widget = {
      ...widget,
      data: {
        ...(widget.data || {}),
        menuData: structuredClone(activeMenuData), // Stores menuData in the exact same format
        selectedItemIds,
      },
    };
    return updatedWidget;
  });
}